import React from 'react';
import { Steps, Popover, Progress, Tooltip, Button } from 'antd';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import services from '../../services';
import WizardModalForm from '../common/wizard_modal_form';
import Main from '../../Pages/Demo/main';
import Lang from '../../lang'
import LegalFrameWorkModal from '../common/matrixArticleModalForm'
import { Input } from '@progress/kendo-react-inputs';
import RowDeatils from '../common/RowDeatils';
import Calculator from '../common/calculator/Calculator';
import LocationSelection from '../common/LocationSelection';
import $ from 'jquery'
import ParcelVirsion from '../Parcel-Right-panel/ParcelVirsion';
import TlkTable from '../tlelrik/table/tlkTable';
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";

const { Step } = Steps;
const customDot = (dot, { title }) => (
  <Popover
    content={
      <span>
        {title}
      </span>
    }
  >
    {dot}
  </Popover>
);

const castaKeyOrder = [
  "Casta",
  "Sinónimo",
  "Tipo Casta",
  "Cor",
  "Fator Castas",
  "Fator DO Porto",
  "Percentagem"
]

const ParcelPointFactors = {
  "fplocalizacao": "location",
  "fpaltitude": "Altitude",
  "fpexposicao": "Exposure",
  "fpinclinacao": "Inclination",
  "fpabrigo": "shelter",
  "fpnaturterreno": "Nat.Terrenno",
  "fppedregosidade": "stony",
  "fpcastas": "grapevarieties",
  "fpidadevinha": "vineage",
  "fpprodutividade": "productivity",
  "fpcompasso": "compass",
  "fparmacao": "wire"
};

const parcelSettlementCharacteristics = {
  "compasso": "Compass",
  "densidade": "Densidade",
  "prctLss3AndFailures": "PrLss3AndFailures",
  "prctfaults": "perfaults",
  "pesmaioR3": "PesGtr3years",
  "pesmenoR3": "pesLss3years",
  "pesilegais": "Illegalfeet",
  "pestotals": "Pestotals",
  "pesramleg": "CoolRamada",
  "falhasram": "Ramadafemales",
  "pesfalileg": "Illegalfaults",
  "pesfalleg": "Legalfaults",
  "pescastasnaoaptas": "Pesvarietiesnotsuitable",
  "pessemaramacao": "Feetwithoutwire",
  // "armacaoterreno": "armacaoterreno"
};

const ParcelPopulationDetails = {
  "bacelos": "bacon",
  "enxertoS1": "Grafts1year",
  "videiraS2": "Vines2years",
  "videiraS3": "Vines3years",
  "videiraS4A25": "Vines4to25years",
  "videirasmaioR25": "Vines>25years"
};

const ParcelPopulationDetailsSemEnqLegal = {
  "bacelosileg": "bacon",
  "enxertoS1ILEG": "Grafts1year",
  "videiraS2ILEG": "Vines2years",
  "videiraS3ILEG": "Vines3years",
  "videiraS4A25ILEG": "Vines4to25years",
  "videirasmaioR25ILEG": "Vines>25years"
};
const castasInputs = {
  "pcttinta": "Casta tinta",
  "pctbranca": "Casta branca",
  "pctrose": "Casta rose",
  "pctmoscatel": "Casta moscatel"
};


const combolistrequest = {
  "Filters": null,
  "SortBy": "",
  "IsSortTypeDESC": true,
  "IsPagination": false,
  "Page": 2,
  "PageSize": 2
};

const intConst = {
  //"numparc": 1,
  //"geocod": 1,
  "areapotential": 1,
  "areaeffective": 1,
  "areaeqlegal": 1,
  "fatordporto": 1,
  "fatoraptidao": 1,
  "fatorporto": 1,
  "papv": 1,
  "portal": 1,
  "sitdeclar": 1,
  "mcp": 1,
  "legalizavel": 1,
  "pontuacao": 1,
  "idsitparc": 1,
  "anoplantacao": 1,
  "idtpestadovinha": 1,
  "groudFrame": 1,
  "estimatedProduction": 1,
  "codlitigio": 1,
  "idclasseplant": 1,
  "potentialarea": 1,
  "affectiveArea": 1,
  "areaWithoutEnqNice": 1,
  "doPort": 1,
  "fitnessFactor": 1,
  "factorPortGrapeVarieties": 1,
  "parcelid": 1,
  "fplocalizacao": 1,
  "fpaltitude": 1,
  "fpexposicao": 1,
  "fpinclinacao": 1,
  "fpabrigo": 1,
  "fpnaturterreno": 1,
  "fppedregosidade": 1,
  "fpcastas": 1,
  "fpidadevinha": 1,
  "fpprodutividade": 1,
  "fpcompasso": 1,
  "fparmacao": 1,
  //"compasso": 1,
  "densidade": 1,
  "prctLss3AndFailures": 1,
  "prctfaults": 1,
  "pesmaioR3": 1,
  "pesmenoR3": 1,
  "pesilegais": 1,
  "pestotals": 1,
  "pesramleg": 1,
  "falhasram": 1,
  "pesfalileg": 1,
  "pesfalleg": 1,
  "pescastasnaoaptas": 1,
  "pessemaramacao": 1,
  "type": 1,
  "bacelos": 1,
  "enxertoS1": 1,
  "videiraS2": 1,
  "videiraS3": 1,
  // "vines4Years": 1,
  "videiraS4A25": 1,
  "videirasmaioR25": 1,
  "pcntRedvariety": 1,
  "pcntwhiteVariety": 1,
  "pcntMuscatGrapeVariety": 1,
  "pctmoscatel": 1,
  "pcntRoseVariety": 1,
  "pcttinta": 1,
  "pctbranca": 1,
  "pctrose": 1,
  "nrartigo": 1
}

const ReadOnly = {
  'classe': 1,
  'areaeqlegal': 1,
  'areaeffective': 1,
  'areapotential': 1,
  'pestotals': 1,
  'prctfaults': 1,
  'prctLss3AndFailures': 1,
  'densidade': 1,
  'pctbranca': 1,
  'pcttinta': 1,
  'pctrose': 1
}

const createTableModule = ['castaparc', "matrixArticle"]


class WizardFormComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      datePicker: "",
      parceldata: {},
      ParcelPointFactorsdivs: "",
      parcelSettlementCharacteristicsdivs: "",
      ParcelPopulationDetailsdivs: "",
      ParcelPopulationDetailsSemEnqLegaldivs: "",
      ShowLogsorVersionnum: 0,
      CastasInputs: "",
      sel_nev: "parcel",
      detailPopUp: "",
      stepNumber: 0,
      auditList: [],
      telkikTable: {},
      matrixlist: [],
      busentconcelho: [],
      BusEntFreguesia: [],
      activeIndex: 'step0',
      totalDouro: 0,
      totalPorto: 0,
      legalarray: [],
      levantamento: [],
      completeauditList: {},
      Popupupdates: false

    }
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {

    this.setState({
      data: this.props.Parcel,
      parceldata: this.props.Parcel.parcel ? this.props.Parcel.parcel : {},
      activeIndex: "step" + (this.state.parceldata.idtpestadovinha || 0)
    }, () => {
      this.props.updatesel_nev('parcel')
      this.setOtherDetails();
      this.castaCompleteForm()
      // this.checkParcelCastaParcField()
      if (this.props.Parcel && this.props.Parcel.coddis)
        this.getcodconList(this.props.Parcel.coddis)
      if (this.props.Parcel && this.props.Parcel.codcon)
        this.getcodfrglist(this.props.Parcel.codcon)
    })


  }

  componentDidUpdate(preprop) {
    if (preprop.date !== this.props.date) {
      this.setState({
        data: this.props.Parcel,
        parceldata: this.props.Parcel.parcel ? this.props.Parcel.parcel : {},
        activeIndex : "step"+(this.state.parceldata.idtpestadovinha || 0)
      }, () => {
        // this.checkParcelCastaParcField()
        this.castaCompleteForm()
        this.setOtherDetails()
        createTableModule.map((_k, i) => {
          this.createOthersTables(_k);
        })
      })
    }
    // if(this.state.Popupupdates){
    //   this.setState({
    //     Popupupdates:false
    //   },()=>{
    //     setTimeout(() => {
    //       $(".selectedParcelform").trigger("click");
    //     },200);
    //   })
    // }

    if (preprop.id !== this.props.id) {
      this.getAuditList()
    }
  }

  checkParcelCastaParcField = () => {
    let data = this.state.data
    let parceldata = { ...this.state.parceldata }
    if (data.castaparc && data.castaparc.length == 0) {
      parceldata['pcttinta'] = 0
      parceldata['pctbranca'] = 0
      parceldata['pctrose'] = 0
      parceldata['pctmoscatel'] = 0
      data['parcel']['pcttinta'] = 0
      data['parcel']['pctbranca'] = 0
      data['parcel']['pctrose'] = 0
      data['parcel']['pctmoscatel'] = 0
    }
    // this.setState({parceldata , data})
  }


  getAuditList = async () => {
    if (this.state.auditList.length === 0) {
      let data = combolistrequest
      data['modulename'] = 'parcel'
      if (this.state.parceldata) {
        data['id'] = this.state.parceldata.id
      }
      let completeauditList = await services.apiCall.requestApi('/auditlog/getall', data, 'post');
      if (completeauditList) {
        let Auditdata = [...completeauditList]
        Auditdata.map((_row, index) => {
          Object.keys(_row).map(function (key) {
            if (key === 'time') {
              _row[key] = moment(_row.date).format('HH:mm:ss')
            } else if (key === 'date') {
              _row[key] = moment(_row.date).format('DD-MM-YYYY')
            }
            _row[Lang.langCheck.langRequest(key)] = _row[key]
            delete _row[key]
            delete _row['NewRecord']
            delete _row['OldRecord']
            delete _row['UserID']
            delete _row['Id']
            delete _row['Tipo']
            delete _row['Utilizador']
          })
        });
        this.setState({
          auditList: Auditdata,
          completeauditList: completeauditList
        }, () => this.telrikTable(this.state.auditList, 'audit'))
      }
    }
  }



  createOthersTables = (modulename) => {
    let data = { ...this.state.data }
    let langkey = ""
    if (data) {
      let module = data[modulename];

      if (module) {
        if (!Array.isArray(module)) {
          if (Object.keys(module).length === 0)
            return
          module = [module]
        }
        let telericdata = [];
        let telerikRow = {};
        module.map((_row, index) => (
          telerikRow = {},
          Object.keys(_row).map(function (key) {
            if (key === 'time') {
              _row[key] = moment(_row.date).format('LTS')
            } else if (key === 'date') {
              _row[key] = moment(_row.date).format('DD-MM-YYYY')
            }
            langkey = Lang.langCheck.langRequest(key);
            telerikRow[langkey] = _row[key]
          }),
          telericdata.push(telerikRow)
        ));
        this.telrikTable(telericdata, modulename)
      }
    }
  }

  makerowForTable = (_r) => {
    let row = {}
    Object.keys(_r).map((key) => {
      if (key === "iddtplantacao" || key === "iddtorigem" || key === "tipo" || key === "areaapdouro" || key === "areaapporto" || key === "obs" || key === "predioarranque")
        row[Lang.langCheck.langRequest(key)] = _r[key]
    });
    return row;
  }


  setOtherDetails = () => {
    let ParcelPointFactorsdivs = this.createform(ParcelPointFactors, 'parcel');
    let parcelSettlementCharacteristicsdivs = this.createform(parcelSettlementCharacteristics, 'parcel');
    let ParcelPopulationDetailsdivs = this.createform(ParcelPopulationDetails, 'parcel');
    let ParcelPopulationDetailsSemEnqLegaldivs = this.createform(ParcelPopulationDetailsSemEnqLegal, 'parcel');
    let CastasInputsdivs = this.createform(castasInputs, "parcel");

    let legalarray = [];

    this.state && this.state.data && this.state.data.legalFramework &&
      this.state.data.legalFramework.length > 0 &&
      this.state.data.legalFramework.map((row, index) => {
        legalarray.push(this.makerowForTable(row.legalFrameworks));
      })

    this.setState({
      ParcelPointFactorsdivs: ParcelPointFactorsdivs,
      parcelSettlementCharacteristicsdivs: parcelSettlementCharacteristicsdivs,
      ParcelPopulationDetailsdivs: ParcelPopulationDetailsdivs,
      ParcelPopulationDetailsSemEnqLegaldivs: ParcelPopulationDetailsSemEnqLegaldivs,
      parcelGrapes: CastasInputsdivs,
      legalarray
    }, () => {
      this.calFatordporto(this.state.data)
      this.calFatoraptidao(this.state.data)
      this.legalFrameworkCalculation()
      this.telrikTable(this.state.legalarray, "legalFramework")
      if (this.props.id) {
        this.checkCalculateFieldOnEdit()
      }
    })
  }

  createform = (data, keystring) => {
    let parcel = this.state.data;
    let datafinal = [];
    let type = -1;
    if (data && !Array.isArray(data)) {
      datafinal = [data];
    } else {
      type = 2;
      datafinal = data;
    }

    if (type === -1) {
      let parcelobject = parcel[keystring] ? parcel[keystring] : {};
      return this.createfinalform(datafinal, keystring, type, parcelobject);
    }
    if (type === 2) {
      let parcelobject = parcel[keystring] ? parcel[keystring] : [];
      if (parcelobject.length === 0) {
        parcelobject = datafinal
      }

      return parcelobject.map((_rowdata, index) => (
        this.createfinalform(datafinal, keystring, index, _rowdata)
      ))
    }
  }

  createfinalform = (datafinal, keystring, type, parcelobject) => {
    return datafinal.map((_row, index) => (
      this.makeInputs(_row, parcelobject, keystring, type, index)
    ))
  }

  handleSteps = (e, modulename, index) => {
    this.setState({ activeIndex: 'step' + e })
    let key = "idtpestadovinha";
    let value = e;
    let data = { ...this.state.data };
    data[modulename] = data[modulename] ? data[modulename] : {}
    if (index >= 0) {
      data[modulename][index][key] = value;
    } else {
      data[modulename][key] = value;
    }
    this.setState({
      data: data
    }, () => this.props.getcenterformdata(data))
    return true;
  }

  makeInputs = (data, parcelobject, keystring, type, index) => {
    return Object.keys(data).map((key) => (
      <div className="col-md-3" key={index} >
        <div className="input-box active-grey" key={index}>
          <Input
            type="text"
            key={index}
            style={{ width: "100%" }}
            readOnly={ReadOnly[key] ? true : false}
            className="input-1"
            name={key}
            value={parcelobject[key] ? parcelobject[key] : ''}
            label={Lang.langCheck.langRequest(`${data[key]}`)}
            onChange={(e) => this.handleChange(e, keystring, type)}
          />
        </div>
      </div>
    ));
  }

  openRightPopupWithUpdateSelNav = (modulename) => {

  }

  openRightPopup = (modulename, sel_nev = "parcel") => {
    let detailPopUp = '';
    if (modulename === 'Registo') {
      // let logLength = this.state.auditList.length
      detailPopUp = (
        <WizardModalForm date={new Date()} all_list={this.props.all_list} handleAuditSubmit={(comment) => this.handleAuditSubmit(comment)} closePopup={() => this.closePopup()} data={this.state.parceldata} tab={modulename} />
      )
    } else if (modulename === 'legalFramework') {
      detailPopUp = (
        <LegalFrameWorkModal date={new Date()}
          all_list={this.props.all_list}
          getpopUpdata={(data, modulename, index) => this.getpopUpdata(data, modulename, index)}
          getcenterformdata={(data) => this.props.getcenterformdata(data)}
          closePopup={() => this.closePopup()}
          data={this.state.data[modulename] || []}
          tab={modulename} />
      )
    } else {
      detailPopUp = (
        <WizardModalForm date={new Date()} parcel={this.state.data} moduledata={this.state.data[modulename] || []} all_list={this.props.all_list} getpopUpdata={(data, modulename, index) => this.getpopUpdata(data, modulename, index)} closePopup={() => this.closePopup()} data={{}} tab={modulename} />
      )
    }
    this.setState({
      sel_nev: sel_nev,
      detailPopUp: detailPopUp
    }, () => {
      this.props.updatesel_nev(this.state.sel_nev)
    })
  }

  closePopup = () => {
    this.props.updatesel_nev(this.state.sel_nev)
    if (this.props.closePopup) {
      this.props.closePopup();
    }
  }

  legalFrameworkCalculation = () => {
    let data = { ...this.state.data }
    let totalDouro = 0;
    let totalPorto = 0;
    if (data.legalFramework && data.legalFramework.length > 0) {
      data.legalFramework.map(_r => {
        totalDouro += parseInt(_r.legalFrameworks.areaapdouro);
        totalPorto += parseInt(_r.legalFrameworks.areaapporto);
      })
    }

    this.setState({
      totalDouro,
      totalPorto
    })
  }

  getpopUpdata = (formData, modulename) => {
    let data = { ...this.state.data }
    //console.log("SubmitForm ", formData)
    if (modulename === "castaparc") {
      data = this.updatecastaForm(formData, data);
    }
    data[modulename] = formData;
    this.props.getcenterformdata(data)
    this.setState({
      data: data,
      Popupupdates: true
    }, () =>
      this.props.updatesel_nev(this.state.sel_nev));
    // setTimeout(() => {
    //   $(".selectedParcelform").trigger("click");
    // },200);

  }

  updatecastaForm = (formData, data) => {
    let castaobject = ["pctbranca", "pcttinta", "pctrose", "pctmoscatel"];
    if (!data['parcel']) {
      data['parcel'] = {}
    }
    castaobject.map((_row, index) => {
      data['parcel'][_row] = 0;
    })

    formData.map((_row, index) => {
      this.props.all_list.Casta.map((_crow, cindex) => {
        if (parseInt(_row.codcasta) === parseInt(_crow.codcasta)) {
          data['parcel'][castaobject[_crow.idcor - 1]] = parseInt(data['parcel'][castaobject[_crow.idcor - 1]]) + parseInt(_row.pctcasta);
        }
      })
    })
    return data;
  }

  castaCompleteForm = () => {
    let data = { ...this.state.data }
    let formData = data['castaparc'] || []
    let castaobject = ["pctbranca", "pcttinta", "pctrose", "pctmoscatel"];
    if (!data['parcel']) {
      data['parcel'] = {}
    }
    castaobject.map((_row, index) => {
      data['parcel'][_row] = 0;
    })
    if (formData.length > 0 && this.props.all_list && this.props.all_list.Casta) {
      formData.map((_row, index) => {
        this.props.all_list.Casta.map((_crow, cindex) => {
          if (parseInt(_row.codcasta) === parseInt(_crow.codcasta)) {
            data['parcel'][castaobject[_crow.idcor - 1]] = parseInt(data['parcel'][castaobject[_crow.idcor - 1]]) + parseInt(_row.pctcasta);
          }
        })
      })
    }

    this.setState({
      data
    })
  }

  handleAuditSubmit = (comment) => {
    //   let data = {
    //     comment: comment
    //   }

    //   let insertRes = await services.apiCall.requestApi(`/auditlog/Comment/${id}`, data, 'post')
    //   if (insertRes) {
    //     this.getAuditList()
    //     this.props.closePopup()
    //   }
    let data = { ...this.state.data }
    data['parcel']['Observações'] = comment
    this.setState({
      data
    })
  }

  makeproperarray = (dataarray) => {
    let proper = [];
    dataarray.map((_rowdata, index) => (
      Object.keys(_rowdata).length > 0 &&
      proper.push(_rowdata)
    ))
    return proper
  }

  calDensidade = (value, data) => {
    if (!data['parcel']) {
      data['parcel'] = {}
    }
    data['parcel']['densidade'] = parseInt((10000 / value) * 100);
    return data

  }

  calPrctLss3AndFailures = (data) => {
    if (!data['parcel']) {
      data['parcel'] = {}
    }
    // data['parcel']['prctLss3AndFailures'] = parseInt((10000 / value) * 100);
    if (data.parcel.pesfalleg && data.parcel.pesmaioR3 && data.parcel.pesmenoR3) {
      let povoamentoPotential = (data.parcel.pesmaioR3 + data.parcel.pesmenoR3 + data.parcel.pesfalleg)
      data.parcel['prctLss3AndFailures'] = parseInt(((povoamentoPotential - data.parcel.pesmaioR3) / povoamentoPotential) * 100)
    } else {
      data.parcel['prctLss3AndFailures'] = ''
    }
    return data
  }

  calPrctfaults = (data) => {
    if (!data['parcel']) {
      data['parcel'] = {}
    }

    if (data.parcel.pesfalleg && data.parcel.pesmaioR3 && data.parcel.pesmenoR3)
      data.parcel['prctfaults'] = parseInt(data.parcel.pesfalleg / (data.parcel.pesfalleg + data.parcel.pesmaioR3 + data.parcel.pesmenoR3) * 100);
    else {
      data.parcel['prctfaults'] = ''
    }
    return data
  }

  calPestotals = (data) => {

    if (!data['parcel']) {
      data['parcel'] = {}
    }
    if (data.parcel.pesfalleg && data.parcel.pesmaioR3 && data.parcel.pesmenoR3)
      data.parcel['pestotals'] = (data.parcel.pesmaioR3 + data.parcel.pesmenoR3 + data.parcel.pesfalleg)
    else {
      data.parcel['pestotals'] = ''
    }
    return data
  }


  calAreapotential = (data) => {

    if (!data['parcel']) {
      data['parcel'] = {}
    }
    if (data.parcel.pesfalleg && data.parcel.pesmaioR3 && data.parcel.pesmenoR3 && data.parcel.compasso)
      data.parcel['areapotential'] = parseInt((data.parcel.pesmaioR3 + data.parcel.pesmenoR3 + data.parcel.pesfalleg) * data.parcel.compasso / 100);

    return data
  }

  calAreaeffective = (data) => {

    if (!data['parcel']) {
      data['parcel'] = {}
    }
    if (data.parcel.pesmaioR3 && data.parcel.compasso)
      data.parcel['areaeffective'] = parseInt(data.parcel.pesmaioR3 * data.parcel.compasso / 100);
    data.parcel['areaeqlegal'] = data.parcel['areaeffective'];
    return data
  }

  calFatordporto = (data) => {

    if (!data['legalFramework']) {
      data['legalFramework'] = {}
    }
    if (data.legalFramework.areaapdouro && data.legalFramework.areaapporto)
      data.parcel['fatordporto'] = parseInt((data.legalFramework.areaapdouro + data.legalFramework.areaapporto) / data.legalFramework.areaapporto);
    return data
  }

  calFatoraptidao = (data) => {
    let castasum = 0;
    if (!data['parcel']) {
      data['parcel'] = {}
    }
    if (data.castaparc) {
      data['castaparc'].map((_row, index) => {
        castasum += parseInt(_row.pctcasta)
      });
      data.parcel['fatoraptidao'] = castasum / 100;
    }
    return data
  }

  handleUpdateClasse = (pontuacaoValue, data) => {
    let classe = '';
    if (pontuacaoValue >= 1200) classe = 'A';
    else if (1200 > pontuacaoValue && pontuacaoValue >= 1001) classe = 'B';
    else if (1000 >= pontuacaoValue && pontuacaoValue >= 801) classe = 'C';
    else if (800 >= pontuacaoValue && pontuacaoValue >= 601) classe = 'D';
    else if (600 >= pontuacaoValue && pontuacaoValue >= 401) classe = 'E';
    else if (400 >= pontuacaoValue && pontuacaoValue >= 201) classe = 'F';
    else if (200 >= pontuacaoValue && pontuacaoValue >= 1) classe = 'G';
    else if (0 >= pontuacaoValue && pontuacaoValue >= -200) classe = 'H';

    if (!data['parcel']) {
      data['parcel'] = {}
    }
    data['parcel']['classe'] = classe
    return data
  }

  checkCalculateFieldOnEdit = () => {
    // para preencher o campo calculado no momento da edição
    let data = { ...this.state.data }
    let value = null
    Object.keys(data['parcel']).map(key => {
      value = data['parcel'][key]
      // if (key === "coddis") {
      //   this.getcodconList(value);
      // } else if (key === "codcon") {
      //   this.getcodfrglist(data['parcel']['coddis']+'-'+value);
      // }
      // if (key === 'pontuacao') {
      //   data = this.handleUpdateClasse(value, data);
      // }
      if (key === 'compasso') {
        data = this.calDensidade(value, data);
        // data = this.calPrctLss3AndFailures(value, data);
      }
      if (key === 'pesfalleg' || key === 'pesmaioR3' || key === "pesmenoR3") {
        data = this.calPrctLss3AndFailures(data);
        data = this.calPestotals(data);
        data = this.calPrctfaults(data);

      }
      if (key === 'pesfalleg' || key === 'pesmaioR3' || key === "pesmenoR3" || key === "compasso") {
        data = this.calAreapotential(data);

      }
      if (key === 'pesmaioR3' || key === "compasso") {
        data = this.calAreaeffective(data);

      }
    })
  }

  handleChange = (e, modulename, index) => {
    if (this.props.isEnable(e.target.name)) {
      return
    }
    let key = e.target.name;
    let value = e.target.value;
    let data = { ...this.state.data }
    if (key === "coddis") {
      this.getcodconList(value);
    } else if (key === "codcon") {
      this.getcodfrglist(value);
    }
    else if (key === 'pontuacao') {
      data = this.handleUpdateClasse(value, data);
    }
    else if (key === 'compasso') {
      data = this.calDensidade(value, data);
      // data = this.calPrctLss3AndFailures(value, data);
    }


    if (intConst[key]) {
      if (value !== "-") {
        value = isNaN(Number(value)) ? "" : Number(value);
      }
    }
    if (index >= 0) {
      data[modulename] = data[modulename] ? data[modulename] : []
    } else {
      data[modulename] = data[modulename] ? data[modulename] : {}
    }

    if (index >= 0) {
      data[modulename][index] = data[modulename][index] ? data[modulename][index] : {}
      data[modulename][index][key] = value;
    } else {
      data[modulename][key] = value;
    }

    if (key === 'pesfalleg' || key === 'pesmaioR3' || key === "pesmenoR3") {
      data = this.calPrctLss3AndFailures(data);
      data = this.calPestotals(data);
      data = this.calPrctfaults(data);

    }
    if (key === 'pesfalleg' || key === 'pesmaioR3' || key === "pesmenoR3" || key === "compasso") {
      data = this.calAreapotential(data);

    }
    if (key === 'pesmaioR3' || key === "compasso") {
      data = this.calAreaeffective(data);

    }

    this.setState({
      data: data
    }, () => this.props.getcenterformdata(data))
    return true;
  }

  getcodconList = async (id) => {
    let busentconcelho = [];
    let res = await services.apiCall.requestApi("/busentconcelho/getbyid/" + id, {}, 'post');
    if (res) {
      busentconcelho = res
    }
    this.setState({
      busentconcelho
    })
  }

  getcodfrglist = async (id) => {
    id = id.split('-');
    //console.log(id);
    let BusEntFreguesia = [];
    let res = await services.apiCall.requestApi("/BusEntFreguesia/GetByID/" + id[1], {}, 'get');
    if (res) {
      BusEntFreguesia = res
    }
    this.setState({
      BusEntFreguesia
    })
  }


  handleDatePicker = () => {
    let datePicker = "";

    datePicker = (<DatePicker
      className="form-control deadlineclender input-1"
      size="middle"
      placeholder="Data última vistoria"
      label="Data última vistoria"
      format={dateShowFormat}
      onChange={this.handleDate}
    />)
    let data = { ...this.state.data }
    let date = "";
    if (data && data.parcel) {
      date = data.parcel.dtultvist;
      if (date) {
        date = moment(date).format(dateShowFormat);

        datePicker = (
          <div>
            <span class="deadlineclenderlable">Data última vistoria</span>
            <DatePicker
              className="form-control deadlineclender input-1"
              size="middle"
              placeholder="Data última vistoria"
              label="Data última vistoria"
              value={new Date(date)}//moment(, dateFormat)}
              format={dateShowFormat}
              readOnly={this.props.isEnable("dtultvist")}
              onChange={this.handleDate}
            />
          </div>
        )
      }
    }
    return datePicker;
  }

  fieldCalculation = () => {
    return 0;
  }

  handleDate = (e) => {
    let data = { ...this.state.data }
    data['parcel'] = data['parcel'] ? data['parcel'] : {}
    data['parcel']['dtultvist'] = e && e._d && moment(e._d).format(dateFormat)
    this.setState({
      data
    })
  }

  handleCheck = (e, modulename, index) => {
    if (this.props.isEnable(e.target.name)) {
      return
    }
    let data = { ...this.state.data };
    data[modulename] = data[modulename] ? data[modulename] : {}
    let module = data[modulename];
    let key = e.target.name;

    let value = module[key] ? 0 : 1;
    if (index >= 0) {
      data[modulename][index][key] = value;
    } else {
      data[modulename][key] = value;
    }
    this.setState({
      data: data
    }, () => this.props.getcenterformdata(data))
    return true;
  }

  telrikTable = (data, modulename) => {
    let columnkeyMap = {}
    let noExport = true
    let collepsview = false
    if (modulename === 'castaparc') {
      collepsview = true
      noExport = true
    }
    if (data.length > 0) {
      if (modulename === 'castaparc') {
        data.map((_r, i) => {
          if (this.props.all_list.Casta && this.props.all_list.Casta.length > 0) {
            let casta = this.props.all_list.Casta.filter(_c => _c.codcasta == _r.Codcasta)
            if (casta.length > 0) _r['Casta'] = casta[0].descasta
            else _r['Casta'] = '';
          }
          if (this.props.all_list.colors && this.props.all_list.colors.length > 0) {
            let cor = this.props.all_list.colors.filter(_c => _c.idcor == _r.Idcor)
            if (cor.length > 0) _r['Cor'] = cor[0].descor
            else _r['Cor'] = '';
          }
          if (this.props.all_list.Sinonimo && this.props.all_list.Sinonimo.length > 0) {
            let Sinonimo = this.props.all_list.Sinonimo.filter(_c => _c.idsinonimo == _r.Idsinonimo)
            if (Sinonimo.length > 0) _r['Sinónimo'] = Sinonimo[0].descasta
            else _r['Sinónimo'] = '';
          }
        })
      }
      Object.keys(data[0]).map((_k, j) => {
        if (modulename === 'matrixArticle') {
          noExport = true
          if ((_k === 'Fração' || _k === 'Nº Artigo')) {
            columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
          }
        } else if (modulename === 'castaparc') {
          // if(j < 1){
          //   console.log("IIIIII",data)
          //   columnkeyMap['Casta'] = 'Casta'
          //   columnkeyMap['Cor'] = 'Cor'
          //   columnkeyMap['Percentagem'] = 'Percentagem'
          // }
          if (_k === 'Casta' || _k === 'Percentagem' || _k === 'Cor') {
            columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
          }
        } else {
          columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
        }
      })

      if (modulename === 'audit') {
        delete columnkeyMap["último registro"];
        delete columnkeyMap["registro antigo"];
      }

      let columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
      });
      data.map((row, index) => {
        row.index = index
        row.modulename = modulename
      })
      let actionbuttons = { Delete: true }
      let telkikTable = this.state.telkikTable

      if (modulename === 'audit') {
        actionbuttons = { Popup: true }
      } if (modulename === 'legalFramework') {
        actionbuttons = { ...actionbuttons, LegalPopup: true }
      }
      if (modulename === 'audit') {
        telkikTable[modulename] = <TlkTable
          key={Object.keys(telkikTable).length}
          noDownloadButton={true}
          date={new Date()}
          list={data}
          modulename={modulename}
          castaKeyOrder={castaKeyOrder}
          // collepsview={true}
          // viewFor="auditdetails"
          actionbuttons={actionbuttons}
          // notAction={true}
          columnlist={columnlist}
          deleteFunc={(id) => this.deleteFunc(id)}
          ActionPerform={(action, id) => this.ActionPerform(action, id)} />

      } else {
        telkikTable[modulename] = <Main
          key={Object.keys(telkikTable).length}
          noExport={noExport}
          date={new Date()}
          list={data}
          modulename={modulename}
          castaKeyOrder={castaKeyOrder}
          collepsview={collepsview}
          viewFor="casta"
          actionbuttons={actionbuttons}
          columnlist={columnlist}
          deleteFunc={(id) => this.deleteFunc(id)}
          ActionPerform={(action, id) => this.ActionPerform(action, id)} />
      }

      this.setState({
        telkikTable: telkikTable
      });
    }
  }

  deleteFunc = (_row) => {
    //console.log("to delete:", _row);
    let data = { ...this.state.data };

    data[_row.modulename].splice(_row.index, 1);
    let telkikTable = { ...this.state.telkikTable }
    telkikTable[_row.modulename] = null;
    // if (_row.modulename === "castaparc") {
    //   data = this.updatecastaForm(data[_row.modulename], data)
    // }
    // this.props.getcenterformdata(data)
    this.setState({
      data,
      telkikTable
    }, () => {
      this.castaCompleteForm()
      this.createOthersTables(_row.modulename)
      this.props.getcenterformdata(data)
    })
    return true;
  }

  ShowLogsorVersion = (n) => {
    let ShowLogsorVersionnum = n
    this.setState({
      ShowLogsorVersionnum
    })

  }
  showRowDeatils = (action, row) => {
    let completeauditList = { ...this.state.completeauditList }
    let detailPopUp = ''
    console.log(action);
    if (action === 'detailsPopup') {
      detailPopUp = (
        <RowDeatils date={new Date()} popUpFor={action} record={completeauditList[row.index] || {}} />
      )
    } if (action === 'legalPopup') {
      detailPopUp = (
        <RowDeatils date={new Date()} popUpFor={action} record={row} />
      )
    }
    this.setState({
      detailPopUp: detailPopUp
    })
  }

  ActionPerform = (action, row) => {
    this.showRowDeatils(action, row);
  }

  calculator = () => {
    let detailPopUp = (
      <Calculator />
    )
    this.setState({
      detailPopUp
    })
  }

  getLocationData = (key, value) => {
    let data = { ...this.state.data };
    data["parcel"] = data["parcel"] ? data["parcel"] : {};
    if (key === 'distrito_id') {
      data["parcel"].coddis = value;
      data["parcel"].codcon = "";
      data["parcel"].codfrg = "";
    } else if (key === 'country_id') {
      data["parcel"].codcon = value;
      data["parcel"].codfrg = "";
    } else if (key === 'fregusia_id') {
      data["parcel"].codfrg = value;
    }
    this.setState({
      data: data
    }, () => this.props.getcenterformdata(data))
    return true;
  }


  /*  para renderizar o conteúdo html da página   */
  render() {

    return (
      <div className="right-section">
        <div className="bg-white middle p20" id="parcel">
          <form className="parcelforms" rel={'parcel'} data={-1}>
            <div className="head mb-4">
              <h2>Resumo do registo</h2>
            </div>
            <div className="row">
</div>


          </form>

        </div>
        <div className="bg-white middle p20 mt-140 position-relative" id="fact_pont">
          <Tooltip title="Obter pontuação" color={"#333"}>
            <span onClick={this.fieldCalculation} className="add-pic">
              <img src="imgs/pic-icon.png" />
            </span>
          </Tooltip>
          <div className="head mb-4">
            <h2 id="parcelPointFactors">Características do rótulo</h2>
          </div>
          <div className="row">
              <div className="col-md-8">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparc"
                    readOnly={this.props.isEnable("numparc")}
                    value={this.state.parceldata.numparc}
                    label="Nome da Marca"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              </div>

          <div className="row">
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="geocod"
                    value={this.state.parceldata.geocod}
                    readOnly={this.props.isEnable("geocod")}
                    label="Ano"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="geocod"
                    value={this.state.parceldata.geocod}
                    readOnly={this.props.isEnable("geocod")}
                    label="Cor"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Doçura"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Capacidade nominal"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              </div>

              
          <div className="row">
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Álcool"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Documento de cedência de marca"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
            </div>
            
        </div>

        <div className="bg-white middle p20 mt-140" id="link3">
          <div className="head mb-4">
            <h2 id="parcelSettlementCharacteristics">Processo</h2>
          </div>
          <div className="row">
              <div className="col-md-4">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Submetido por"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              
              <div className="col-md-4">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Data de submissão do pedido"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
          </div>


            <div className="row">

              <div className="col-md-3">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" onChange={(e) => this.handleCheck(e, 'parcel')} className="custom-control-input" id="customCheck7" name="seloincorporado" checked={this.state.parceldata.ignorvalid} />
                  <label className="custom-control-label" htmlFor="customCheck7">Selo Incorporado</label>
                </div>
              </div>
              <div className="col-md-3">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" onChange={(e) => this.handleCheck(e, 'parcel')} className="custom-control-input" id="customCheck8" name="marcapropria" checked={this.state.parceldata.areaprojectada} />
                  <label className="custom-control-label" htmlFor="customCheck8">Marca Própria</label>
                </div>
              </div>
              <div className="col-md-3">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" onChange={(e) => this.handleCheck(e, 'parcel')} className="custom-control-input" id="customCheck9" name="logowinesofportugal" checked={this.state.parceldata.ignorvalid} />
                  <label className="custom-control-label" htmlFor="customCheck9">Logo Wines Of Portugal</label>
                </div>
              </div>
              <div className="col-md-3">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" onChange={(e) => this.handleCheck(e, 'parcel')} className="custom-control-input" id="customCheck10" name="baginbox" checked={this.state.parceldata.areaprojectada} />
                  <label className="custom-control-label" htmlFor="customCheck10">Bag in Box (BiB)</label>
                </div>
            </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Email de notificação"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
              
              <div className="col-md-4">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numparant"
                    value={this.state.parceldata.numparant}
                    readOnly={this.props.isEnable("numparant")}
                    label="Mercado / País"
                    onChange={(e) => this.handleChange(e, 'parcel')}
                  />
                </div>
              </div>
          </div>



        </div>

        <div className="bg-white middle p20 mt-140 position-relative" id="link4">
          <Tooltip title="Inserir Imagens" color={"#333"}>
            <span data-toggle="modal" data-target='#left-popup-center' onClick={() => this.openRightPopup("matrixArticle", "matrixArticle")} className="add-plus cursor-pointer"><i className="fas fa-plus"></i></span>
          </Tooltip>
          <div className="head mb-4">
            <h2 id="matrixArticle"> Imagens</h2>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive table-section inner-table">
                {
                  this.state.telkikTable.matrixArticle ?
                    this.state.telkikTable.matrixArticle :
                    <p>Sem dados associados</p>

                }
              </div>
            </div>
          </div>

        </div>
        <div className="bg-white middle p20 mt-140 position-relative" id="link4">
          <Tooltip title="Aplicar Direitos" color={"#333"}>
            <span data-toggle="modal" data-target='#left-popup-center' onClick={() => this.openRightPopup("legalFramework", "Enquadramento")} className="add-plus cursor-pointer"><i className="fas fa-plus"></i></span>
          </Tooltip>
          <div className="head mb-4">
            <h2 id="Enquadramento"> Processamento</h2>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex justify-content-between">
                <div className="font-400">Total Direitos Aplicados</div>
                {/* <div>4000</div>  */
                }
              </div>
              <div className="progress">
                <Progress percent={parseInt(this.state.totalPorto)} status="active" />
              </div>
              <div className="d-flex justify-content-between mt-4">
                <div className="font-500">Area Sem Direitos Aplicados/Enquadrados</div>
                {/* <div>4000</div>  */
                }
              </div>
              <div className="progress mb-4">
                <Progress percent={parseInt(this.state.totalPorto / this.state.totalDouro)} status="active" />
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">{

              this.state.telkikTable.legalFramework
            }

            </div>
          </div>
        </div>

        <div className="modal left-popup" id="left-popup-center">
          <div className="modal-dialog modal-lg">
            {this.state.detailPopUp}
          </div>
        </div>
      
      
      </div>
    )
  }
}


export default WizardFormComponent;